import * as React from "react";
import FilterToolbar from "../../../../Components/FiltersToolbar/FilterToolbar";
import { FilterInputType } from "../../../../Enums/FilterTypes";
import { DefaultCreatedDateSort, DefaultPerPageSize } from "../../../../Constants/Constant";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import { SourceRequestOrder } from "../../Constant/Source";
import { DataGridColumns } from "./DataGridColumns";
import { ExcelExport } from "../../../../Helper/ExportExcel";
import { Drawer, Grid, makeStyles } from "@material-ui/core";
import RequestOrderNotes from "../RequestOrderNotes";
import { RemarkTypes } from "../../../../../src/Enums/RemarkTypes";
import { useVerifyPermission } from "@airborne/react-admin";
import PoolList from "../../../../Components/PoolListComponent/PoolListComponent";

export const useStyles = makeStyles(theme => ({
  drawerPaper: {
    width: "20%",
  },
}));

export const VendorRepairList = props => {
  useVerifyPermission("customroutes", "vendorrepair.read");
  const [isMatchCreate, setIsMatchCreate] = React.useState(false);
  const [requestRemark, setRequestRemark] = React.useState<any>({});
  const classes = useStyles();

  const ExportToExcel = data => {
    ExcelExport(
      [
        {
          header: "Status",
          key: "Status",
        },
        {
          header: "Ref No",
          key: "Ref No",
        },
        {
          header: "Customer Po",
          key: "Customer Po",
        },
        {
          header: "Requested Delivery Date",
          key: "Requested Delivery Date",
        },
        {
          header: "Pn",
          key: "Pn",
        },
        {
          header: "Core Unit Sn",
          key: "Core Unit Sn",
        },
        {
          header: "Wo",
          key: "Wo",
        },
        {
          header: "Ro",
          key: "Ro",
        },
        {
          header: "Vendor Repair Start Date",
          key: "Vendor Repair Start Date",
        },
        {
          header: "RMS Note",
          key: "RMS Note",
        },
      ],
      data.map(v => [
        v.requestStatus,
        v.refNo,
        v.customerPo,
        v.requestedDeliveryDate,
        v.customerRequestComponent,
        v.unserviceable?.sn,
        v.wo,
        v.ro,
        v.unserviceable?.updatedDate,
        v.note,
      ]),
      "Vendor Repair List"
    );
  };

  const handleClose = () => {
    setIsMatchCreate(false);
  };

  const remarkAddClick = record => {
    setIsMatchCreate(true);
    setRequestRemark(record);
  };

  return (
    <>
      <PoolList
        {...props}
        title={"Vendor Repair List"}
        hasCreate={false}
        exporter={ExportToExcel}
        resource={SourceRequestOrder}
        basePath={SourceRequestOrder}
        hasBulkActions={false}
        filterDefaultValues={{
          isUnsvcInfo__eq: true,
          requestStatus__eq: RequestStatus.WarrantyWorkscopeVendorProcess,
        }}
        sort={DefaultCreatedDateSort}
        perPage={DefaultPerPageSize}
        filters={
          <FilterToolbar
            dataSource={[
              {
                source: "requestStatus",
                inputType: FilterInputType.Select,
                label: "Status",
                optionText: "label",
                optionValue: "id",
                style: { width: "250px" },
                choices: [
                  {
                    label: "Warranty Work Scope Vendor Process",
                    id: RequestStatus.WarrantyWorkscopeVendorProcess,
                  },
                ],
              },
              {
                source: "refNo",
                inputType: FilterInputType.Text,
                label: "Ref No",
              },
              {
                source: "customerPo",
                inputType: FilterInputType.Text,
                label: "Customer Po",
              },
              {
                source: "requestedDeliveryDate",
                inputType: FilterInputType.Date,
                label: "Requested Delivery Date",
              },
              {
                source: "customerRequestComponent",
                inputType: FilterInputType.Text,
                label: "Pn",
              },
              {
                source: "sn",
                inputType: FilterInputType.Text,
                label: "Sn",
              },
            ]}
          />
        }
      >
        <DataGridColumns remarkAddClick={remarkAddClick} />
      </PoolList>
      {isMatchCreate && (
        <Grid item xs={3}>
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="persistent"
            open={isMatchCreate}
            anchor="right"
            onClose={handleClose}
          >
            {isMatchCreate ? (
              <RequestOrderNotes
                onCancel={handleClose}
                request={requestRemark}
                resource="requestremarks"
                basePath="requestremarks"
                remarkType={RemarkTypes.PbhNote}
              />
            ) : null}
          </Drawer>
        </Grid>
      )}
    </>
  );
};

export default VendorRepairList;
